<template>
  <v-container>
    <v-card>
      <v-tabs
        @change="changeTabColor"
        dark
        height="25px"
        :background-color="tabColor"
        v-model="tab"
        grow
      >
        <v-tab href="#tab-users">Users</v-tab>
        <v-tab href="#tab-administrators">administrators</v-tab>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="tab-users">
            <v-data-table
              :headers="userHeaders"
              :items="userData"
              mobile-breakpoint="300"
            >
              <template #body="{ items }">
                <tbody>
                  <tr v-for="(item, index) in items" :key="item.email">
                    <td>{{ item.firstName }}</td>
                    <td>{{ item.lastName }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.company }}</td>
                    <td>
                      <v-menu
                        offset-y
                        :close-on-content-click="false"
                        v-model="userData[index].pickerShow"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            readonly
                            outlined
                            dense
                            hide-details
                            v-on="on"
                            v-bind="attrs"
                            class="center-text"
                            :value="
                              item.endDate
                                ? df.format(
                                    df.parseISO(item.endDate),
                                    'MM/dd/yyyy'
                                  )
                                : ''
                            "
                          />
                        </template>
                        <v-date-picker
                          no-title
                          scrollable
                          :value="item.endDate"
                          @change="onDateSelect(item, index, ...arguments)"
                        />
                      </v-menu>
                    </td>
                    <td>
                      <div class="d-flex justify-center">
                        <v-menu offset-y>
                          <template #activator="{ on, attrs }">
                            <v-icon v-on="on" v-bind="attrs"
                              >mdi-calendar-edit</v-icon
                            >
                          </template>
                          <v-list>
                            <v-list-item @click="add1Week(item)"
                              >Add 1 week</v-list-item
                            >
                            <v-list-item @click="add1Month(item)"
                              >Add 1 month</v-list-item
                            >
                            <v-list-item @click="add6Months(item)"
                              >Add 6 months</v-list-item
                            >
                            <v-list-item @click="add1Year(item)"
                              >Add 1 year</v-list-item
                            >
                            <v-list-item @click="revokeAccess(item)"
                              >Revoke Access</v-list-item
                            >
                          </v-list>
                        </v-menu>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-center">
                        <v-menu offset-y>
                          <template #activator="{ on, attrs }">
                            <v-icon v-on="on" v-bind="attrs"
                              >mdi-account</v-icon
                            >
                          </template>
                          <v-list>
                            <v-list-item @click="promoteAdmin(item)"
                              >Promote to Administrator</v-list-item
                            >
                            <v-list-item
                              @click="
                                showDeleteAlert(
                                  item.email,
                                  item,
                                  'user'
                                )
                              "
                              >Delete User</v-list-item
                            >
                          </v-list>
                        </v-menu>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-center">
                        <v-icon>{{ item.active | getIcon }}</v-icon>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table></v-tab-item
          >
          <v-tab-item value="tab-administrators">
            <v-data-table
              :headers="adminHeaders"
              :items="adminData"
              mobile-breakpoint="300"
            >
              <template #body="{ items }">
                <tbody>
                  <tr v-for="(item, index) in items" :key="item.email">
                    <td>{{ item.firstName }}</td>
                    <td>{{ item.lastName }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.company }}</td>
                    <td>
                      <div class="d-flex justify-center">
                        <v-menu
                          offset-y
                          v-if="localStorage.email != item.email"
                        >
                          <template #activator="{ on, attrs }">
                            <v-icon v-on="on" v-bind="attrs"
                              >mdi-account</v-icon
                            >
                          </template>
                          <v-list>
                            <v-list-item @click="demoteAdmin(item)"
                              >Demote Administrator</v-list-item
                            >
                            <v-list-item
                              @click="
                                showDeleteAlert(
                                  item.email,
                                  item,
                                  'admin'
                                )
                              "
                              >Delete User
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-icon v-if="localStorage.email == item.email"
                          >mdi-account-lock</v-icon
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>

    <v-dialog v-model="deleteWarning" width="350" persistent>
      <v-card>
        <v-container fill-height class="justify-center align-center">
          <v-row class="ma-5">
            Are you sure you want to delete the account belonging to
            {{ deleteEmail }}?
          </v-row>
          <v-row class="mx-5">
            <v-btn @click="deleteWarning = false">No</v-btn>
            <v-spacer />
            <v-btn class="red" dark @click="deleteAction(deleteItem)"
              >Yes</v-btn
            >
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import * as df from "date-fns";
import axios from "axios";

export default {
  data() {
    return {
      tab: "tab-users",
      tabColor: "green lighten-2",
      df,
      userHeaders: [
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        { text: "Email", value: "email" },
        { text: "Company", value: "company" },
        { text: "Subscription End Date", width: 180, value: "endDate" },
        { text: "Add Time", sortable: false, width: "100px", align: "center" },
        {
          text: "User Actions",
          sortable: false,
          width: "100px",
          align: "center",
        },
        {
          text: "Is User Active",
          value: "active",
          width: "140px",
          align: "center",
        },
      ],
      adminHeaders: [
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        { text: "Email", value: "email" },
        { text: "Company", value: "company" },
        { text: "User Actions", sortable: false },
      ],
      userData: [],
      adminData: [],
      loading: false,
      deleteWarning: false,
      deleteEmail: null,
      item: null,
      deleteAction: null,
    };
  },
  methods: {
    showDeleteAlert(email, item, type) {
      this.deleteEmail = email;
      this.deleteItem = item;
      if (type == "user") this.deleteAction = this.deleteUser;
      if (type == "admin") this.deleteAction = this.deleteAdmin;
      this.deleteWarning = true;
    },
    async deleteUser(item) {
      this.deleteWarning = false;
      const result = await axios({
        method: "delete",
        url: process.env.VUE_APP_API_ADDRESS + "delete",
        data: { email: item.email },
        headers: {
          "content-type": "application/json",
          token: this.localStorage.token,
        },
      });
      this.userData = this.userData.filter((x) => x != item);
    },
    async deleteAdmin(item) {
      this.deleteWarning = false;
      if (item.email == this.localStorage.email) return;
      const result = await axios({
        method: "delete",
        url: process.env.VUE_APP_API_ADDRESS + "delete",
        data: { email: item.email },
        headers: {
          "content-type": "application/json",
          token: this.localStorage.token,
        },
      });
      this.adminData = this.adminData.filter((x) => x != item);
    },
    async onDateSelect(item, index, date) {
      const result = await axios({
        method: "post",
        url: process.env.VUE_APP_API_ADDRESS + "update",
        data: {
          email: item.email,
          date: date,
        },
        headers: {
          "content-type": "application/json",
          token: this.localStorage.token,
        },
      });
      this.userData[index].pickerShow = false;
      this.userData = this.userData.map((x) => {
        if (x == item) {
          x.endDate = date;
          x.active = df.parseISO(date) >= df.startOfToday();
        }
        return x;
      });
    },
    async add1Week(item) {
      let newDate = null;
      if (!item.endDate) {
        newDate = df.format(df.addWeeks(df.startOfToday(), 1), "yyyy-MM-dd");
      } else {
        newDate = df.format(
          df.addWeeks(df.parseISO(item.endDate), 1),
          "yyyy-MM-dd"
        );
      }
      const result = await axios({
        method: "post",
        url: process.env.VUE_APP_API_ADDRESS + "update",
        data: {
          email: item.email,
          date: newDate,
        },
        headers: {
          "content-type": "application/json",
          token: this.localStorage.token,
        },
      });
      this.userData = this.userData.map((x) => {
        if (x == item) {
          x.endDate = newDate;
          x.active = df.parseISO(newDate) >= df.startOfToday();
        }
        return x;
      });
    },
    async add1Month(item) {
      let newDate = null;
      if (!item.endDate) {
        newDate = df.format(df.addMonths(df.startOfToday(), 1), "yyyy-MM-dd");
      } else {
        newDate = df.format(
          df.addMonths(df.parseISO(item.endDate), 1),
          "yyyy-MM-dd"
        );
      }
      const result = await axios({
        method: "post",
        url: process.env.VUE_APP_API_ADDRESS + "update",
        data: {
          email: item.email,
          date: newDate,
        },
        headers: {
          "content-type": "application/json",
          token: this.localStorage.token,
        },
      });
      this.userData = this.userData.map((x) => {
        if (x == item) {
          x.endDate = newDate;
          x.active = df.parseISO(newDate) >= df.startOfToday();
        }
        return x;
      });
    },
    async add6Months(item) {
      let newDate = null;
      if (!item.endDate) {
        newDate = df.format(df.addMonths(df.startOfToday(), 6), "yyyy-MM-dd");
      } else {
        newDate = df.format(
          df.addMonths(df.parseISO(item.endDate), 6),
          "yyyy-MM-dd"
        );
      }
      const result = await axios({
        method: "post",
        url: process.env.VUE_APP_API_ADDRESS + "update",
        data: {
          email: item.email,
          date: newDate,
        },
        headers: {
          "content-type": "application/json",
          token: this.localStorage.token,
        },
      });
      this.userData = this.userData.map((x) => {
        if (x == item) {
          x.endDate = newDate;
          x.active = df.parseISO(newDate) >= df.startOfToday();
        }
        return x;
      });
    },
    async add1Year(item) {
      let newDate = null;
      if (!item.endDate) {
        newDate = df.format(df.addYears(df.startOfToday(), 1), "yyyy-MM-dd");
      } else {
        newDate = df.format(
          df.addYears(df.parseISO(item.endDate), 1),
          "yyyy-MM-dd"
        );
      }
      const result = await axios({
        method: "post",
        url: process.env.VUE_APP_API_ADDRESS + "update",
        data: {
          email: item.email,
          date: newDate,
        },
        headers: {
          "content-type": "application/json",
          token: this.localStorage.token,
        },
      });
      this.userData = this.userData.map((x) => {
        if (x == item) {
          x.endDate = newDate;
          x.active = df.parseISO(newDate) >= df.startOfToday();
        }
        return x;
      });
    },
    async revokeAccess(item) {
      const result = await axios({
        method: "post",
        url: process.env.VUE_APP_API_ADDRESS + "update",
        data: {
          email: item.email,
          date: null,
        },
        headers: {
          "content-type": "application/json",
          token: this.localStorage.token,
        },
      });
      this.userData = this.userData.map((x) => {
        if (x == item) {
          x.endDate = null;
          x.active = false;
        }
        return x;
      });
    },
    async promoteAdmin(item) {
      let result = await axios({
        method: "post",
        url: process.env.VUE_APP_API_ADDRESS + "accesslevel",
        data: {
          email: item.email,
          accessLevel: "admin",
        },
        headers: {
          "content-type": "application/json",
          token: this.localStorage.token,
        },
      });
      if (result.data != "user updated") return console.log(result.data);
      this.userData = this.userData.filter((x) => x != item);
      this.adminData = [...this.adminData, item];
    },
    async demoteAdmin(item) {
      if (item.email == this.localStorage.email) return;
      let result = await axios({
        method: "post",
        url: process.env.VUE_APP_API_ADDRESS + "accesslevel",
        data: {
          email: item.email,
          accessLevel: "user",
        },
        headers: {
          "content-type": "application/json",
          token: this.localStorage.token,
        },
      });
      if (result.data != "user updated") return console.log(result.data);
      this.adminData = this.adminData.filter((x) => x != item);
      this.userData = [...this.userData, item];
    },
    changeTabColor() {
      if (this.tab == "tab-users") {
        this.tabColor = "green lighten-2";
      } else {
        this.tabColor = "red lighten-2";
      }
    },
  },
  filters: {
    getIcon(active) {
      if (active) {
        return "mdi-check-box-outline";
      } else {
        return "mdi-checkbox-blank-outline";
      }
    },
  },
  async beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (vm.localStorage.token) {
        const result = await axios({
          method: "get",
          url: process.env.VUE_APP_API_ADDRESS + "adminverify",
          headers: { token: vm.localStorage.token },
        });
        if (result.data == "passed") return;
        console.log(result.data);
        vm.localStorage.token = null;
        vm.localStorage.accessLevel = null;
        vm.localStorage.email = null;
        vm.localStorage.endDate = null;
      }
      next("/");
    });
  },
  async mounted() {
    this.loading = true;
    let result = await axios({
      method: "get",
      url: process.env.VUE_APP_API_ADDRESS + "users",
      headers: {
        token: this.localStorage.token,
      },
    });
    this.loading = false;
    if (!Array.isArray(result.data)) return console.log(result.data);
    this.userData = result.data.map((x) => {
      return {
        ...x,
        pickerShow: false,
        active: df.parseISO(x.endDate) >= df.startOfToday(),
      };
    });
    result = await axios({
      method: "get",
      url: process.env.VUE_APP_API_ADDRESS + "admins",
      headers: {
        token: this.localStorage.token,
      },
    });
    if (!Array.isArray(result.data)) return console.log(result.data);
    this.adminData = result.data;
  },
};
</script>

<style scoped>
.center-text >>> input {
  text-align: center;
}
</style>
